import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import PdfLinkDownload from '@/shared/navigation/pdf-link/PdfLinkDownload.vue';
import TransparencyList from '@/shared/product/details/ui/product-specifications/TransparencyList.vue';
import useProductSpecificationsTile
    from '@/shared/product/details/ui/product-specifications/useProductSpecificationsTile';
import { Test } from '@/types/productServerApi';


export default /*#__PURE__*/_defineComponent({
  __name: 'TestsList',
  props: {
    tests: null,
    title: { default: '' }
  },
  setup(__props: any) {



const { transparencyReadMoreLinks } = useProductSpecificationsTile();
const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TransparencyList, {
    title: __props.title,
    "read-more-label": _unref(labels).readMoreAboutTestsLabel,
    "read-more-link": _unref(transparencyReadMoreLinks).readMoreAboutTestsLink
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tests, (test) => {
        return (_openBlock(), _createElementBlock("li", {
          key: test.name,
          class: "mb-x4"
        }, [
          _createElementVNode("div", null, _toDisplayString(test.name), 1),
          (test.documentUrl)
            ? (_openBlock(), _createBlock(PdfLinkDownload, {
                key: 0,
                class: "mt-x2",
                label: _unref(labels).transparencyDocumentationDownload,
                "is-direct-link": true,
                url: test.documentUrl
              }, null, 8, ["label", "url"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["title", "read-more-label", "read-more-link"]))
}
}

})